<template>
  <div class="expense-speed">
    <div class="speed-header">
      <h3>지출 속도</h3>
      <div class="period-selector">
        <button 
          v-for="period in periods" 
          :key="period.value"
          :class="['period-btn', { active: selectedPeriod === period.value }]"
          @click="selectedPeriod = period.value"
        >
          {{ period.label }}
        </button>
      </div>
    </div>
    <div class="speed-list">
      <div v-for="speed in speedStats" :key="speed.category" class="speed-item">
        <div class="speed-header">
          <span class="category">{{ speed.category }}</span>
          <span class="total">{{ formatNumber(speed.total) }}원</span>
        </div>
        <div class="speed-bar-container">
          <div 
            class="speed-bar" 
            :style="{ 
              width: `${speed.percentage}%`,
              backgroundColor: getBarColor(speed.percentage)
            }"
          >
            <span class="speed-bar-text">
              {{ formatNumber(speed.average) }}원/{{ periodUnit }}
            </span>
          </div>
        </div>
        <div class="speed-details">
          <span class="period">{{ speed.periodText }}</span>
          <span class="interval">(평균 {{ speed.interval }}일 간격)</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { expenseStore } from '../store/expense'

export default {
  name: 'ExpenseSpeed',
  data() {
    return {
      selectedPeriod: 'daily',
      periods: [
        { value: 'daily', label: '일별' },
        { value: 'weekly', label: '주별' },
        { value: 'monthly', label: '월별' },
        { value: 'yearly', label: '연간' }
      ]
    }
  },
  computed: {
    periodUnit() {
      switch(this.selectedPeriod) {
        case 'daily': return '일';
        case 'weekly': return '주';
        case 'monthly': return '월';
        case 'yearly': return '년';
      }
    },
    speedStats() {
      const expenses = expenseStore.expenses.value
      const stats = {}

      // 카테고리별 통계 계산
      expenses.forEach(expense => {
        if (!stats[expense.category]) {
          stats[expense.category] = {
            total: 0,
            dates: new Set(),
            firstDate: new Date(expense.date),
            lastDate: new Date(expense.date),
            count: 0  // 지출 횟수 추가
          }
        }

        const stat = stats[expense.category]
        stat.total += expense.amount
        stat.dates.add(new Date(expense.date).toDateString())
        stat.count++  // 지출 횟수 증가
        
        const expenseDate = new Date(expense.date)
        if (expenseDate < stat.firstDate) stat.firstDate = expenseDate
        if (expenseDate > stat.lastDate) stat.lastDate = expenseDate
      })

      // 통계 데이터 가공
      const processedStats = Object.entries(stats).map(([category, stat]) => {
        // 총 기간 계산 (일 단위)
        const totalDays = Math.max(
          1,
          (Math.ceil((stat.lastDate - stat.firstDate) / (1000 * 60 * 60 * 24))) + 1
        )

        // 지출 간격 계산 (지출횟수가 1회일 경우 1로 처리)
        console.log('stat.count', stat.count)
        console.log('totalDays', totalDays)

        const interval = stat.count > 1 ? (totalDays - 1) / (stat.count - 1) : 1
        console.log('interval', interval)

        // 평균 지출액 계산
        let average = Math.round(stat.total / stat.count)
        console.log('average', average)

        // 일 평균 지출액 계산
        const dailyAverage = Math.round(average / interval)
        console.log('dailyAverage', dailyAverage)

        let periodText
        switch(this.selectedPeriod) {
          case 'daily':
            average = dailyAverage
            periodText = `${totalDays}일 동안 ${stat.count}회 지출`
            break
          case 'weekly':
            average = dailyAverage * 7
            periodText = `${Math.ceil(totalDays / 7)}주 동안 ${stat.count}회 지출`
            break
          case 'monthly':
            average = dailyAverage * 30
            periodText = `${Math.ceil(totalDays / 30)}개월 동안 ${stat.count}회 지출`
            break
          case 'yearly':
            average = dailyAverage * 365
            periodText = `${Math.ceil(totalDays / 365)}년 동안 ${stat.count}회 지출`
            break
        }

        return {
          category,
          total: stat.total,
          average,
          periodText,
          count: stat.count,
          interval: Math.round(interval * 10) / 10,  // 소수점 1자리까지 표시
          dailyAverage
        }
      })

      // 최대 평균 지출액 계산
      const maxAverage = Math.max(...processedStats.map(s => s.average))

      // 퍼센티지 계산 추가
      return processedStats
        .map(stat => ({
          ...stat,
          percentage: Math.round((stat.average / maxAverage) * 100)
        }))
        .sort((a, b) => b.average - a.average)
    }
  },
  methods: {
    formatNumber(number) {
      return number.toLocaleString()
    },
    getBarColor(percentage) {
      if (percentage > 80) return '#f44336'
      if (percentage > 60) return '#ff9800'
      if (percentage > 40) return '#2196F3'
      if (percentage > 20) return '#4CAF50'
      return '#78909C'
    }
  }
}
</script>

<style scoped>
.expense-speed {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
}

.speed-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.speed-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.period-selector {
  display: flex;
  gap: 6px;
}

.period-btn {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.period-btn.active {
  background-color: #2196F3;
  color: white;
  border-color: #2196F3;
}

.period-btn:hover:not(.active) {
  background-color: #f5f5f5;
}

.expense-speed h3 {
  margin: 0 0 20px 0;
  font-size: 18px;
  color: #333;
}

.speed-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.speed-item {
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.speed-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.category {
  font-weight: bold;
  font-size: 16px;
  color: #333;
}

.total {
  color: #666;
  font-size: 14px;
}

.speed-bar-container {
  height: 32px;
  background-color: #e9ecef;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 8px;
}

.speed-bar {
  height: 100%;
  min-width: 50px;
  border-radius: 6px;
  transition: width 0.3s ease;
  display: flex;
  align-items: center;
  padding: 0 10px;
}

.speed-bar-text {
  color: white;
  font-weight: bold;
  font-size: 14px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
}

.speed-details {
  display: flex;
  justify-content: space-between;
  color: #666;
  font-size: 13px;
  margin-top: 4px;
}

.interval {
  color: #888;
  font-size: 12px;
}

@media (max-width: 600px) {
  .expense-speed {
    padding: 15px;
  }

  .speed-header {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }

  .period-selector {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .period-btn {
    padding: 8px;
    font-size: 15px;
    text-align: center;
  }

  .speed-item {
    padding: 12px;
  }

  .category {
    font-size: 15px;
  }

  .speed-bar {
    padding: 0 8px;
  }

  .speed-bar-text {
    font-size: 13px;
  }

  .speed-details {
    flex-direction: column;
    gap: 4px;
    font-size: 12px;
  }
}
</style> 